import { gql } from '@apollo/client';

export * from './softwareEscrowAgreementTerms.query.generated';

export const SOFTWARE_ESCROW_AGREEMENT_TERMS = gql`
  query softwareEscrowAgreementTerms($softwareEscrowId: ID!) {
    softwareEscrowTerms: softwareEscrow(softwareEscrowId: $softwareEscrowId) {
      agreement {
        terms
        termsDownloadPdfUrl
        termsSignedDownloadPdfUrl
        termsDownloadDocxUrl
      }
    }
  }
`;
